import 'css/index.css';
import { initializeArdoqPackages } from 'initializeArdoqPackages';
import { initRouter } from 'auth/AuthRouter';
import { initializeFeatureInterface } from 'modelInterface/features/initializeFeatureInterface';
import { bootstrapPreAppI18n } from 'preAppI18nBootstrap';

initializeFeatureInterface();
initializeArdoqPackages();

bootstrapPreAppI18n().finally(initRouter);
